import { render, staticRenderFns } from "./MessageWidgetQuoted.vue?vue&type=template&id=6b87ac76&"
import script from "./MessageWidgetQuoted.vue?vue&type=script&lang=js&"
export * from "./MessageWidgetQuoted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports